import { ToggleButton } from "@clipboard-health/ui-components";

import { FiltersToggleButtonGroup } from "./BottomSheet/ToggleButtonGroup";
import { type FiltersFormValues } from "./BottomSheet/types";

interface FavoriteWorkplacesFilterProps {
  value: FiltersFormValues["favoriteWorkplacesOnly"];
  onChange: (value: FiltersFormValues["favoriteWorkplacesOnly"]) => void;
}

export function FavoriteWorkplacesFilter(props: FavoriteWorkplacesFilterProps) {
  const { value, onChange } = props;

  return (
    <FiltersToggleButtonGroup
      value={value ? ["favorites"] : []}
      aria-label="Favorite Workplaces Filter Toggle Button"
      onChange={(newValue) => {
        onChange(newValue?.includes("favorites") ?? false);
      }}
    >
      <ToggleButton value="favorites" iconType="like-filled">
        Favorites only
      </ToggleButton>
    </FiltersToggleButtonGroup>
  );
}
